export const getBackendUrl = (configuredUrl = process.env.REACT_APP_BACKEND_URL) => {
  const origin = window.location.origin;
  const hostname = window.location.hostname;

  if (hostname === 'insights.trilogyoneconsulting.com' || hostname.endsWith('.trilogyoneconsulting.com')) {
    return origin;
  }

  return configuredUrl || origin;
};

export const getApiUrl = (configuredUrl = process.env.REACT_APP_BACKEND_URL) => `${getBackendUrl(configuredUrl)}/api`;
